import { AnimatedLoader, Loader } from '@/components/shared/loader';
import { useAppInit } from '@/hooks/useAppInit';
import { ErrorBoundary } from 'react-error-boundary';
import { RouterProvider } from 'react-router-dom';
import { SessionTracker } from './components/session/sessionTracker';
import { routerDefault, routerForError } from './routes';

function ErrorBoundaryFallback() {
  return <RouterProvider router={routerForError} />;
}

const App = () => {
  const { isLoading, isInitialized, isUnderMaintenance } = useAppInit();

  if (!isInitialized) {
    return <Loader />;
  }

  if (isUnderMaintenance) {
    return <Loader title="Under maintenance" description="Updating systems..." />;
  }

  return (
    <ErrorBoundary fallback={<ErrorBoundaryFallback />}>
      <AnimatedLoader isVisible={isLoading} />
      <RouterProvider router={routerDefault} />
      <SessionTracker />
    </ErrorBoundary>
  );
};

export default App;
